import template from './user-client-details.html';
import userClientDetailsController from './user-client-details.controller';
import './user-client-details.styl';

let userClientDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template,
  controller: userClientDetailsController,
  controllerAs: 'vm'
};

export default userClientDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-client-details/user-client-details.component.js
 **/